import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpCommonService, ShowToastrService } from "projects/sepidz-web-framework/src/lib/services";
import { take, timeout } from "rxjs/operators";

@Injectable()
export class PosScaleService {
  public Url: string;
  public isConnected: boolean = false;
  constructor(private httpCommonService: HttpCommonService, private sts: ShowToastrService) {}

  connect() {
    return this.httpCommonService.getCustom(`${this.Url}/Connect`).pipe(take(1), timeout(3000));
  }

  connection() {
    return this.httpCommonService.getCustom(`${this.Url}/CheckConnection`).pipe(take(1), timeout(3000));
  }

  checkConnection() {
    this.connection().subscribe({
      next: (res: any) => {
        this.isConnected = res.isConnected;
        if (res.isConnected) this.sts.showToast("success", "", "اتصال با ترازو برقرار شد.", 5000);
        else this.sts.showToast("danger", "", res.Message, 5000);
      },
      error: (err) => {
        this.sts.showDialog("مشکل در برقراری اتصال با ترازو، لطفا تنظیمات محلی ترازو را بررسی کنید.", "خطا");
      },
    });
  }

  async tare() {
    try {
      this.httpCommonService
        .getCustom(`${this.Url}/Tare`)
        .pipe(timeout(3000))
        .toPromise()
        .then(
          (resolve: any) => {
            this.sts.showToast("success", "", resolve.Message);
          },
          (reject) => {
            this.sts.showDialog("اشکال در اندازه گیری پارسنگ.", "خطا");
          }
        );
    } catch {}
  }

  async getWeight() {
    try {
      return this.httpCommonService
        .getCustom(`${this.Url}/GetWeight`)
        .pipe(timeout(3000))
        .toPromise()
        .then(
          (resolve: any): number => {
            return parseFloat(resolve.weight);
          },
          (reject) => {
            this.sts.showDialog("خطا در اندازه گیری وزن", "خطا");
          }
        );
    } catch {}
  }
}
